import { Card, CardContent, Skeleton, Typography } from "@mui/material";

const ChartCard = ({ title, loading, children }) => (
  <Card sx={{ p: 2, borderRadius: 4, boxShadow: 3, width: "100%" }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={280} sx={{ borderRadius: 2 }} />
      ) : (
        children
      )}
    </CardContent>
  </Card>
);

export default ChartCard;